import i18n from "@/plugins/i18n";
import format from "date-fns/format";
import nl from "date-fns/locale/nl";
import en from "date-fns/locale/en";

function getLanguage(id) {
  return languages.find((language) => language.id === id);
}

const languages = [
  {
    locale: "nl",
    datepickerLocale: "nl-NL",
    fnsLocale: nl,
    name: "Nederlands",
    id: 1,
  },
  {
    locale: "en",
    datepickerLocale: "en-GB",
    fnsLocale: en,
    name: "English",
    id: 2,
  },
];

export default {
  namespaced: true,
  state: {
    language: {
      locale: "en",
      datepickerLocale: "en-en",
      fnsLocale: en,
      name: "English",
      id: 2,
    },
    languages: languages.sort((a, b) => a.name.localeCompare(b.name)),
    titleKey: "",
  },
  mutations: {
    changeLanguage: (state, id) => {
      state.language = getLanguage(id);
      i18n.locale = state.language.locale;
      localStorage.language = id;
    },
    updatePageTitle: (state, title) => {
      state.titleKey = title;
      document.title =
        process.env.VUE_APP_TITLE + " - " + i18n.t(state.titleKey);
    },
  },
  actions: {
    changeLanguage: (context, id) => {
      context.commit("changeLanguage", id);
    },
    updatePageTitle: (context, title) => {
      context.commit("updatePageTitle", title);
    },
  },
  getters: {
    formattedDate: (state) => (date) => {
      return date
        ? format(date.date, date.format, { locale: state.language.fnsLocale })
        : "";
    },
  },
};
